import { useCreateExperience } from './useCreateExperience';
import { useUpdateExperience } from './useUpdateExperience';
import {
  buildRequest,
  isEndDateBeforeStart,
  submitCreate,
  submitUpdate,
} from '../components/ExperienceFormDialog.utils';
import type {
  UseExperienceSubmitParams,
  UseExperienceSubmitReturn,
} from './useExperienceSubmit.types';

export function useExperienceSubmit({
  mode,
  candidateId,
  experience,
  handleSubmit,
  setError,
  reset,
  onClose,
}: UseExperienceSubmitParams): UseExperienceSubmitReturn {
  const { createExperience, isLoading: isCreating } = useCreateExperience();
  const { updateExperience, isLoading: isUpdating } = useUpdateExperience();

  const onSubmit = handleSubmit((data) => {
    if (isEndDateBeforeStart(data)) {
      setError('endYear', { message: 'End date must be after start date' });
      return;
    }
    const request = buildRequest(data);
    if (mode === 'create') {
      submitCreate(createExperience, {
        candidateId,
        request,
        onDone: () => {
          reset();
          onClose();
        },
      });
    } else if (mode === 'edit' && experience) {
      submitUpdate(updateExperience, experience.id, { candidateId, request, onDone: onClose });
    }
  });

  return { onSubmit, isLoading: isCreating || isUpdating };
}
